import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { getUserName } from 'src/data/user';
import { formatDateTimeDiffNow, formatUpdatedDateTime } from 'src/lib/format';

import { useStyles } from './useStyles';

export const ProjectFolderDescription = ({ className, classes, projectFolder, diffNow }) => {
  const styles = useStyles({ classes });

  const dateModified = useMemo(() => {
    if (diffNow) {
      return formatDateTimeDiffNow(projectFolder.projectUpdatedAt);
    } else {
      return formatUpdatedDateTime(projectFolder.projectUpdatedAt);
    }
  }, [projectFolder, diffNow]);

  return (
    <div className={cx(styles.root, className)}>
      <TruncatedTypography variant={TYPOGRAPHY_VARIANT.regular14}>
        {dateModified} by {getUserName(projectFolder.user)}
      </TruncatedTypography>
    </div>
  );
};

ProjectFolderDescription.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape(),
  projectFolder: PropTypes.shape().isRequired,
  diffNow: PropTypes.bool,
};
ProjectFolderDescription.defaultProps = {
  className: null,
  classes: null,
  diffNow: false,
};
